// Imperative per-frame delivery channel for linked-scroll commands.
// Continuous LINK input must not re-render ViewerPage and every mounted viewport.
// Durable toggle/seed state remains in useLinkedScroll for late mounts; this channel
// carries only live latest-wins commands between accepted source frames and panes.
export const VIEWPORT_LINKED_SCROLL_COMMAND_CHANNEL_MARKER = 'KAIROS_VIEWPORT_LINKED_SCROLL_COMMAND_CHANNEL';

const EMPTY_CHANNEL_STATE = Object.freeze({ version: 0, payload: null });

export const createViewportLinkedScrollCommandChannel = () => {
  let state = EMPTY_CHANNEL_STATE;
  const subscribers = new Set();
  return {
    marker: VIEWPORT_LINKED_SCROLL_COMMAND_CHANNEL_MARKER,
    publish(payload) {
      state = { version: state.version + 1, payload: payload || null };
      subscribers.forEach(subscriber => {
        try { subscriber(state.payload); } catch (_) { /* isolate subscribers */ }
      });
    },
    subscribe(listener) {
      if (typeof listener !== 'function') return () => {};
      subscribers.add(listener);
      // Late-mounted or newly series-ready panes must observe current LINK
      // authority immediately; otherwise they can fall back to an old toggle
      // seed until the source happens to accept another frame.
      try { listener(state.payload); } catch (_) { /* isolate subscribers */ }
      return () => subscribers.delete(listener);
    },
    getSnapshot() {
      return state;
    },
  };
};
